import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=10b3bd42&scoped=true"
import script from "./NavButtons.vue?vue&type=script&lang=js"
export * from "./NavButtons.vue?vue&type=script&lang=js"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=10b3bd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3bd42",
  null
  
)

export default component.exports